require("./index.html");
require("./img/favicon.png");
require("normalize.css/normalize.css");
require("./main.css");
